import { create } from "zustand";

// 약관 모달(전역 렌더)에서 가입 약관 화면으로 "동의" 신호를 전달하는 스토어.
// 모달 props는 sessionStorage에 직렬화되므로 함수 콜백 대신 termsId(숫자)로 신호한다.
interface TermsAgreeState {
  pendingAgreeId: number | null;
  requestAgree: (termsId: number) => void;
  clear: () => void;
}

export const useTermsAgreeStore = create<TermsAgreeState>((set) => ({
  pendingAgreeId: null,
  requestAgree: (termsId) => set({ pendingAgreeId: termsId }),
  clear: () => set({ pendingAgreeId: null }),
}));
